<template>
  <div>
    <div class="grid gap-1">
      <p class="opacity-50">{{ labelText }}:</p>

      <div class="input-room-wrapp relative px-4 py-2 cursor-pointer select-none bg-white input-border whitespace-nowrap truncate">{{textToDisplay}}</div>
    </div>
    
    <vue-slider :value="value" v-bind="$attrs" @change="handleInput" />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { formatPrice, addPrefixAndSuffix } from '../../../lib/utils'

export default {
  components: {
    VueSlider,
  },
  name: 'inputInterval',
  props: {
    labelText: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: [0, 100],
    },
    prefix: String,
    suffix: String,
  },
  computed: {
    textToDisplay() {
      const [min, max] = this.value
      return addPrefixAndSuffix(`${formatPrice(min)} - ${formatPrice(max)}`, this.prefix, this.suffix)
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
  }
}
</script>